import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import ConformanceTooltip from './conformanceTooltip';
import { conformanceSelector, enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import SinglePicker from '../../common/controls/singlePicker';
import useLookup from '../../../utils/useLookup';
import logValueOnChange from '../commonActions/logValueOnChange';
const prepareOptions = list => {
  const result = list.map(item => ({
    id: item.id,
    title: item.name
  }));
  return result;
};
const PhaseCodePickerField = _ref => {
  let _ref$conformanceText = _ref.conformanceText,
    conformanceText = _ref$conformanceText === void 0 ? null : _ref$conformanceText,
    enabled = _ref.enabled,
    _ref$jobPhaseCode = _ref.jobPhaseCode,
    indexQuery = _ref$jobPhaseCode.indexQuery,
    list = _ref$jobPhaseCode.list,
    serverFilter = _ref.jobPhaseCodeActions.serverFilter,
    jobID = _ref.jobID,
    _ref$label = _ref.label,
    incomingLabel = _ref$label === void 0 ? 'Phase Code' : _ref$label,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    path = _ref.path;
  const label = useLookup(incomingLabel);
  const showConformance = !!conformanceText;
  useEffect(() => {
    // The serverFilter jobID filter is unused (params.filters.jobID) but will trigger reloads
    // as necessary when jobs change. indexQuery.jobID (params.jobID) is what the server uses.
    // Unfortunately there are a few dependencies in the web app that make changing this hard.
    const updatedIndexQuery = _objectSpread(_objectSpread({}, indexQuery), {}, {
      jobID
    });
    serverFilter({
      jobID
    }, updatedIndexQuery);
  }, [jobID, indexQuery, serverFilter] // server filter and index query should never change
  );
  const handleChange = useCallback(incomingValue => {
    const displayValue = incomingValue ? incomingValue.title : null;
    onChange({
      path,
      value: incomingValue,
      displayValue
    });
  }, [onChange, path]);
  const id = "pcpf-".concat(kebabCase(label));
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    "data-testid": id
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    placeholder: "Select ".concat(useLookup('Phase Code')),
    label: label,
    labelKey: "title",
    options: prepareOptions(list),
    onChange: handleChange,
    value: value,
    valueKey: "id",
    className: "".concat(showConformance ? 'is-invalid' : '', " t-pcpf"),
    disabled: !enabled //  single picker is a basic compoent, not FB
    ,
    verticalPadding: false
  }), /*#__PURE__*/React.createElement(ConformanceTooltip, {
    errorText: conformanceText,
    target: id,
    placement: "right"
  }));
};
PhaseCodePickerField.propTypes = {
  conformanceText: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  jobID: PropTypes.string.isRequired,
  jobPhaseCode: PropTypes.shape({
    indexQuery: PropTypes.shape({
      jobID: PropTypes.string
    }).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobPhaseCodeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
};
export { PhaseCodePickerField as UncomposedPhaseCodePickerField };
export default entityComposition(PhaseCodePickerField, ['jobPhaseCode'], {
  conformanceText: conformanceSelector,
  enabled: enabledSelector,
  jobID: state => state.report.active.jobID,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});